<footer>
    <div class="w-100">
      <div class="row row-cols-1 row-cols-md-4 g-4">

        <div class="col">
          <div class="card h-100">
            <div class="card-body">
                <a class="navbar-brand" >
                    <img src="https://framework-gb.cdn.gob.mx/landing/img/logoheader.svg" alt="Bootstrap" width="250" height="94">
                </a>
            </div>

          </div>
        </div>

        <div class="col ">
            <div class="card h-100">
              <div class="card-body">
                <h5 class="card-title">Enlaces</h5>
                <p class="card-text">Participa
                  Publicaciones Oficiales
                  Marco Jurídico
                  Plataforma Nacional de Transparencia
                  Alerta
                  Denuncia</p>
              </div>
            </div>
          </div>
          

        <div class="col">
          <div class="card h-100">
            <div class="card-body">
              <h5 class="card-title">¿Qué es gob.mx?</h5>
              <p class="card-text">
                Es el portal único de trámites, información y participación ciudadana. Leer más

                Portal de datos abiertos
                Declaración de accesibilidad
                Aviso de privacidad integral
                Aviso de privacidad simplificado
                Términos y Condiciones
                Política de seguridad
                Mapa de sitio
              </p>
              
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card h-100">
            <div class="card-body">
              <h5 class="card-title">Denuncia contra servidores públicos</h5>
              <h5 class="card-title">Síguenos en</h5>
              <div>
                <span class="text-light p-3"><i class="fa fa-facebook"></i></span>
                <span class="text-light p-3"><i class="fa fa-twitter" aria-hidden="true"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</footer>